import * as React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import { GetCurrentDatetime, subDays, addDays } from "../../../service/dateTimeService";
import "../../../../assets/scss/components/generic/datePicker.scss";
import moment from "moment";
import { range } from "../../../service/rangeGen";
import bStrg, { setbStrg } from "../../../service/storageHelper";
import DeviceContext from "./../../../service/indentifyDevice";
export interface IDatePickerIntProps {
	sendDates: (frmDt: Date, toDate: Date) => void;
	toDateCt?: number; //number identifies to minus or plus to todate
	plusDays: number;
}
export interface IDatePickerIntState {
	fromDate: Date;
	toDate: Date;
	today: Date;
	toMax: Date;
	fromMax: Date;
	showMnthYrDtPicker: 1 | 2 | 0; //month picker|year picker|datepicker
	years: Array<number>;
}

export default class DatePickerInt extends React.Component<IDatePickerIntProps, IDatePickerIntState> {
	constructor(props: IDatePickerIntProps) {
		super(props);

		this.state = {
			fromDate: subDays(new Date(), this.props.plusDays),
			toDate: subDays(new Date(), !props.toDateCt && props.toDateCt !== 0 ? 1 : props.toDateCt),
			fromMax: new Date(),
			toMax: new Date(),
			today: new Date(),
			showMnthYrDtPicker: 0,
			years: range(12, new Date().getFullYear() - 11)
		};
		this.onFromChange = this.onFromChange.bind(this);
		this.updateWithTodayDate = this.updateWithTodayDate.bind(this);
		this.handleNav = this.handleNav.bind(this);
	}
	isMobile = DeviceContext().isMobile;
	todayDate: string = bStrg("todayDate") || new Date();
	years: Array<number> = [];
	months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	monthsFull = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	onFromChange = (date: any) => {
		let newDate = new Date(date),
			plus15Days = addDays(newDate, this.props.plusDays),
			me = this;

		//check if selected date plus 15 days(ST + 15) is greater than today date
		//else set to date with today's date(T - 1)

		if (plus15Days.valueOf() < this.state.today.valueOf()) {
			this.setState({
				toDate: plus15Days
			});
		} else {
			this.setState({
				toDate: subDays(this.state.today, 0)
			});
		}

		this.setState({
			fromDate: date
		});

		setTimeout(function () {
			me.props.sendDates(me.state.fromDate, me.state.toDate);
		}, 300);
	};

	updateWithTodayDate = (date: string) => {
		this.setState({
			toMax: subDays(new Date(date), !this.props.toDateCt && this.props.toDateCt !== 0 ? 1 : this.props.toDateCt),
			today: new Date(date),
			fromMax: new Date(date),
			fromDate: subDays(new Date(date), this.props.plusDays),
			toDate: subDays(new Date(date), !this.props.toDateCt && this.props.toDateCt !== 0 ? 1 : this.props.toDateCt),
			years: range(12, new Date(date).getFullYear() - 11)
		});
		this.props.sendDates(this.state.fromDate, this.state.toDate);
	};
	componentDidMount() {
		if (!this.todayDate) {
			GetCurrentDatetime((res: any) => {
				if (!res.error) {
					this.todayDate = JSON.parse(res).JsonData;
					setbStrg("todayDate", this.todayDate);
					this.updateWithTodayDate(this.todayDate);
				} else {
					//if api fails
					this.updateWithTodayDate(this.todayDate);
				}
			});
		} else {
			this.updateWithTodayDate(this.todayDate);
		}
	}

	handleNav = (mnthYr?: string) => {
		switch (mnthYr) {
			case "month":
				this.setState({
					showMnthYrDtPicker: 1
				});
				break;
			case "year":
				this.setState({
					showMnthYrDtPicker: 2
				});
				break;
			default:
				this.setState({
					showMnthYrDtPicker: 0
				});
		}
	};
	//return week header in case of month range
	weekX = () => {
		return (
			<div className="react-datepicker__day-names">
				<div className="react-datepicker__day-name">Su</div>
				<div className="react-datepicker__day-name">Mo</div>
				<div className="react-datepicker__day-name">Tu</div>
				<div className="react-datepicker__day-name">We</div>
				<div className="react-datepicker__day-name">Th</div>
				<div className="react-datepicker__day-name">Fr</div>
				<div className="react-datepicker__day-name">Sa</div>
			</div>
		);
	};
	//month picker
	monthPicker = (date: Date, changeMonth: (month: number) => void) => {
		return (
			<>
				<button className="mth_hdr" onClick={() => this.handleNav("year")}>
					{date.getFullYear()}
				</button>

				<ul className="monthPicker">
					{this.months.map((month: string, i: number) => {
						let selectedClass = "";
						if (i === this.state.fromDate.getMonth() || i === this.state.toDate.getMonth()) {
							selectedClass = " selected";
						}
						return (
							<li key={i}>
								<button
									className={
										date.getFullYear() === this.state.today.getFullYear() && i > this.state.today.getMonth()
											? "disabled"
											: "" + selectedClass
									}
									onClick={() => {
										this.handleNav();
										changeMonth(i);
									}}
								>
									{month}
								</button>
							</li>
						);
					})}
				</ul>
			</>
		);
	};
	//year picker
	yearPicker = (changeYear: (year: number) => void) => {
		return (
			<>
				{" "}
				<div className="year_header">
					<button
						onClick={() =>
							this.setState({
								years: range(12, this.state.years[0] - 12)
							})
						}
					>
						<i className="edel-icon-arrow-left  edel_arrow"></i>
					</button>
					<span className="yer" onClick={() => this.handleNav("year")}>
						{this.state.years[0] + "-" + this.state.years[this.state.years.length - 1]}
					</span>
					{/* disable next if exceeding year */}
					<button
						onClick={() =>
							this.setState({
								years: range(12, this.state.years[this.state.years.length - 1] + 1)
							})
						}
						disabled={this.state.today.getFullYear() === this.state.years[this.state.years.length - 1]}
					>
						<i className="edel-icon-arrow-right edel_arrow"></i>
					</button>
				</div>
				<ul className="yearPicker">
					{this.state.years.map((yr: number, i: number) => {
						let selectedClass = "";
						if (yr === this.state.fromDate.getFullYear() || yr === this.state.toDate.getFullYear()) {
							selectedClass = " selected";
						}
						return (
							<li key={i}>
								<button
									className={"yer" + selectedClass}
									onClick={() => {
										this.handleNav();
										changeYear(yr);
									}}
								>
									{yr}
								</button>
							</li>
						);
					})}
				</ul>
			</>
		);
	};
	//custom calender header
	CustomCalenHeader = (
		date: Date,
		changeYear: (year: number) => void,
		changeMonth: (month: number) => void,
		decreaseMonth: () => void,
		increaseMonth: () => void,
		prevMonthButtonDisabled: boolean,
		nextMonthButtonDisabled: boolean,
		decreaseYear: () => void,
		increaseYear: () => void,
		prevYearButtonDisabled: boolean,
		nextYearButtonDisabled: boolean
	): React.ReactNode => {
		return (
			<div>
				{this.state.showMnthYrDtPicker === 0 && (
					<div className="date_picker_hdr">
						<div className="monthHeaders">
							<label className="month_header">
								<button className="arwLeft arrw" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
									<i className="edel-icon-arrow-left edel_arrow"></i>
								</button>
								<span>
									<button className="mth" onClick={() => this.handleNav("month")}>
										{this.isMobile ? this.monthsFull[date.getMonth()] : this.months[date.getMonth()]}{" "}
									</button>
									<button className="year" onClick={() => this.handleNav("year")}>
										‘{date.getFullYear().toString().slice(2)}
									</button>
								</span>
								{/* //in case if dates fall in same month */}
								{new Date(this.state.fromDate).getMonth() === new Date(this.state.toDate).getMonth() && (
									<button className="arwRight arrw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
										<i className="edel-icon-arrow-right edel_arrow"></i>
									</button>
								)}
								{new Date(this.state.fromDate).getMonth() <= new Date(this.state.toDate).getMonth() && this.isMobile && (
									<button className="arwRight arrw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
										<i className="edel-icon-arrow-right edel_arrow"></i>
									</button>
								)}
							</label>
							{this.isMobile && (
								<label className="mob_range">
									{moment(this.state.fromDate).format("DD MMM ’YY")} - {moment(this.state.toDate).format("DD MMM ‘YY")}
								</label>
							)}
							{/* //show date range if to and from falls in two different months */}
							{/* Don;t show date range in mobile */}
							{!this.isMobile && new Date(this.state.fromDate).getMonth() !== new Date(this.state.toDate).getMonth() && (
								<label className="month_header toRightAl">
									<span>
										<button className="mth" onClick={() => this.handleNav("month")}>
											{this.months[this.months.length <= date.getMonth() + 1 ? 0 : date.getMonth() + 1]}{" "}
										</button>
										<button className="year" onClick={() => this.handleNav("year")}>
											‘
											{this.months.length <= date.getMonth() + 1
												? (date.getFullYear() + 1).toString().slice(2)
												: date.getFullYear().toString().slice(2)}
										</button>
									</span>
									{!nextMonthButtonDisabled && (
										<button className="arwRight arrw" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
											<i className="edel-icon-arrow-right edel_arrow"></i>
										</button>
									)}
								</label>
							)}
						</div>
						{new Date(this.state.fromDate).getMonth() !== new Date(this.state.toDate).getMonth() && (
							<div className="react-datepicker__day-names-custom">
								{this.weekX()}
								{!this.isMobile && this.weekX()}
							</div>
						)}
					</div>
				)}
				{/* show month picker */}

				{this.state.showMnthYrDtPicker === 1 && this.monthPicker(date, changeMonth)}
				{/* show year picker */}
				{this.state.showMnthYrDtPicker === 2 && this.yearPicker(changeYear)}
			</div>
		);
	};
	public render() {
		return (
			<div className="calenContainer">
				<DatePicker
					renderCustomHeader={({
						date,
						changeYear,
						changeMonth,
						decreaseMonth,
						increaseMonth,
						prevMonthButtonDisabled,
						nextMonthButtonDisabled,
						decreaseYear,
						increaseYear,
						prevYearButtonDisabled,
						nextYearButtonDisabled
					}) =>
						this.CustomCalenHeader(
							date,
							changeYear,
							changeMonth,
							decreaseMonth,
							increaseMonth,
							prevMonthButtonDisabled,
							nextMonthButtonDisabled,
							decreaseYear,
							increaseYear,
							prevYearButtonDisabled,
							nextYearButtonDisabled
						)
					}
					onCalendarClose={() => this.handleNav()}
					dateFormat="dd MMM yy"
					selected={this.state.fromDate}
					onChange={(date) => {
						this.onFromChange(date);
					}}
					selectsStart
					selectsEnd
					startDate={this.state.fromDate}
					endDate={this.state.toDate}
					maxDate={this.state.toMax}
					calendarClassName={
						(this.state.showMnthYrDtPicker !== 0
							? "hideDp"
							: new Date(this.state.fromDate).getMonth() !== new Date(this.state.toDate).getMonth()
							? "rangeCalen"
							: "") + " ib vMid"
					}
					monthsShown={
						this.isMobile
							? 1
							: new Date(this.state.fromDate).getMonth() !== new Date(this.state.toDate).getMonth() &&
							  this.state.showMnthYrDtPicker === 0
							? 2
							: 1
					}
					showPreviousMonths={
						new Date(this.state.toDate).getMonth() < new Date(this.state.fromDate).getMonth() && this.state.showMnthYrDtPicker === 0
					}
					customInput={
						<label className="dateNIconDisp ib">
							<i className="edel-icon-calendar"></i>
							<span className="frmtedDate">
								{moment(this.state.fromDate).format("DD MMM ’YY")} - {moment(this.state.toDate).format("DD MMM ‘YY")}
							</span>
						</label>
					}
					showPopperArrow={false}
				/>
			</div>
		);
	}
}
